import { StoryLevelData } from "@/app/lib/levels/story-level-data-types";
import { parseBuilderText } from "@/app/builder/build-parser";

const builderText =
`"crackerjacks"
BaLk
waLk
StrIkE
#krtwa

BunT
FOul
SInglE
dOuBlE
gROundOuT
#dlnug

sLiDer
siNKer
spLiTTer
#psrei`

const id = 'baseball-0.1'

const parsed = parseBuilderText(builderText, id);

if (parsed.levelData === null) {
    throw new Error(`Invalid builder text for ${id}`);
}

export const baseball: StoryLevelData = parsed.levelData;